import { FC } from 'react';
import './NoMenuLayout.scss';

export const NoMenuLayout: FC = ({ children }) => <div className="no-menu-wrapper container-xl">{children}</div>;
